var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-banner", attrs: { id: "home" } }, [
      _c("div", { staticClass: "banner-info" }, [
        _vm._m(0),
        _c("div", { staticClass: "middile-inner-con" }, [
          _vm._m(1),
          _c("div", { staticClass: "tab-main mx-auto" }, [
            _c(
              "label",
              [
                _c("span", {
                  staticClass: "fa fa-home",
                  attrs: { "aria-hidden": "true" }
                }),
                _c("router-link", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页")
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w3pvt-logo text-center" }, [
      _c("h1", [
        _c("a", { attrs: { href: "https://404.life/" } }, [
          _vm._v("404网页模板")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "inner-w3layouts-wrap" }, [
      _c("h4", [
        _vm._v(
          "\n            抱歉，当你看到这个页面的时候，表示你要找的网页已经丢失了。\n            "
        ),
        _c("br"),
        _c("br"),
        _vm._v("别担心，你可以返回首页继续你的网站之旅！\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy-w3layouts-right text-center pb-3" }, [
      _c("p", [_vm._v("\n        Copyright © 2019\n      ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }